const strings = {
  locations: {
    addLocation: "ADD LOCATION",
    viewDashboard: "View Dashboard",
    issues: (issueCount: number) => `${issueCount} Issues`,
    noIssues: "No issues",
    oneDevice: "1 Device",
    noLocationData: "No Location Information Received",
    multiDevices: (deviceAmt: number) => `${deviceAmt} Devices`,
    addDevices: "Add devices",
    modal: {
      addLocationDescription:
        "Adding locations allows you to organize and filter devices by their location. Once you add new locations, visit device settings to add the corresponding devices to the new location.",
      editLocationDescription:
        "Editing locations allows you to edit an existing location's name and address fields.",
      locationName: "LOCATION NAME",
      address: "ADDRESS",
      locationPlaceholder: "Location",
      addressPlaceholder: "123 Main St, City, State, Zip",
      addLocation: "ADD LOCATION",
      editLocation: "SAVE",
      removeLocation: "Remove Location",
      existingLocations: "Existing Locations",
      successTitle: "Location Updates Saved",
      successMessage: "Your updates were saved.",
      errorTitle: "Unable to Save Location Updates",
      errorMessage: "Your updates were not saved. Please try again later.",
      addedSuccessTitle: "Confirmed",
      addedSuccessMessage: (locationName: string) =>
        `${locationName} was added, you can now add devices to this location.`,
      addedErrorTitle: "Error",
      addedErrorMessage: (locationName: string) =>
        `${locationName} was not added, please try again later.`,
      noLocations: "No locations added.",
    },
  },
};

export default strings;
